import crypto from 'crypto-js';

const ITERATION_COUNT = 65536;
const KEY_LENGTH = 256;

export function getKeyFromPassword(password, salt) {
    const derivedKey = crypto.PBKDF2(
        password,
        salt,
        {
            keySize: KEY_LENGTH / 32,
            iterations: ITERATION_COUNT,
            hasher: crypto.algo.SHA256
        });
    return  derivedKey.toString(crypto.enc.Base64)
}

/**
 * Desencripta una cadena de texto en formato Base64 utilizando el algoritmo AES/CBC/PKCS5PADDING y la clave proporcionada.
 * @param cipherText La cadena de texto encriptada en formato Base64.
 * @param pass Clave secreta.
 * @param keyBase64 La clave secreta para el cifrado en Base64.
 * @param ivBase64 El vector de inicialización para el cifrado en modo CBC en Base64.
 * @returns La cadena de texto desencriptada.
 */
export function decryptPasswordBasedBackend(cipherText, pass, keyBase64, ivBase64) {
    try {
        // Convertir la clave y el IV de Base64 a formatos adecuados
        const key = crypto.enc.Base64.parse(getKeyFromPassword(pass, atob(keyBase64)));
        const iv = crypto.enc.Base64.parse(ivBase64);

        // Desencriptar el texto cifrado
        const decryptedBytes = crypto.AES.decrypt(cipherText, key, { iv: iv });

        // Convertir los bytes desencriptados a texto UTF-8
        const decryptedMessage = decryptedBytes.toString(crypto.enc.Utf8);
        // console.log(atob(decryptedMessage));
        // console.log(decryptedMessage);
        return decryptedMessage ? JSON.parse(decodeBase64ToUtf8(decryptedMessage)) : null;
    } catch (e) {
        console.log('Error al desencriptar:', e);
        return null;
    }
}

function decodeBase64ToUtf8(base64String) {
    if (!base64String) {
        return '{}'
    }

    // Decodificar Base64 a datos binarios
    const binaryString = atob(base64String);

    // Crear un ArrayBuffer a partir de los datos binarios
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    // Crear   una cadena UTF-8 a partir del ArrayBuffer
    return new TextDecoder("utf-8").decode(bytes);
}

export function decryptPasswordBased(cipherText, pass, salt, ivBase64) {
    try {
        // Obtener la clave derivada de la contraseña y el salt
        const key = crypto.PBKDF2(
            pass,
            salt,
            { keySize: KEY_LENGTH / 32, iterations: ITERATION_COUNT, hasher: crypto.algo.SHA256 }
        );

        // Convertir el IV de Base64 a formato adecuado
        const iv = crypto.enc.Base64.parse(ivBase64);

        // Desencriptar el texto cifrado
        const decryptedBytes = crypto.AES.decrypt(cipherText, key, { iv: iv });

        // Convertir los bytes desencriptados a texto UTF-8
        const decryptedMessage = decryptedBytes.toString(crypto.enc.Utf8);

        // Devolver el objeto original desencriptado
        return decryptedMessage ? JSON.parse(decryptedMessage) : null;
    } catch (e) {
        return null;
    }
}

export function encryptPasswordBased(plainObject, pass, salt) {
    // Convertir el objeto a JSON string
    const plainText = JSON.stringify(plainObject);

    // Obtener la clave derivada de la contraseña
    const key = crypto.PBKDF2(
        pass,
        salt,
        { keySize: KEY_LENGTH / 32, iterations: ITERATION_COUNT, hasher: crypto.algo.SHA256 }
    );

    // Crear un IV aleatorio
    const iv = crypto.lib.WordArray.random(16);

    // Encriptar el texto
    const encrypted = crypto.AES.encrypt(plainText, key, { iv: iv });

    // Retornar el texto cifrado, IV y clave en Base64
    return {
        cipherText: encrypted.toString(),
        iv: iv.toString(crypto.enc.Base64),
        salt: salt
    };
}

